import * as gtag from '@/common/utils/gtags.client';
import { useEffect } from 'react';
import { generateHashedMetadataPayload } from '@/common/utils/google-tag-manager/generate-hashed-metadata-payload';

export interface UserInformation {
  user_id?: string;
  hashed_city?: string;
  hashed_country?: string;
  hashed_dob?: string;
  hashed_email?: string;
  hashed_external_id?: string;
  hashed_first_name?: string;
  hashed_last_name?: string;
  hashed_phone?: string;
  hashed_state?: string;
  hashed_zip?: string;
}

async function sendUserInformation(user: UserInformation): Promise<void> {
  const payload = generateHashedMetadataPayload(user);
  if (payload) gtag.pushData(payload);
}

export function usePushUserInformationToDataLayer({
  user_id,
  hashed_city,
  hashed_country,
  hashed_dob,
  hashed_email,
  hashed_external_id,
  hashed_first_name,
  hashed_last_name,
  hashed_phone,
  hashed_state,
  hashed_zip,
}: UserInformation): void {
  useEffect(() => {
    sendUserInformation({
      user_id,
      hashed_city,
      hashed_country,
      hashed_dob,
      hashed_email,
      hashed_external_id,
      hashed_first_name,
      hashed_last_name,
      hashed_phone,
      hashed_state,
      hashed_zip,
    });
  }, [
    user_id,
    hashed_city,
    hashed_country,
    hashed_dob,
    hashed_email,
    hashed_external_id,
    hashed_first_name,
    hashed_last_name,
    hashed_phone,
    hashed_state,
    hashed_zip,
  ]);
}
